<template>
  <div class="mt-1 w-75">
    <div style="display: flex;">
      <div class="mr-1">
        <span style="font-weight: 900;">{{ value.usuarioNome }}</span>
      </div>
      <div class="mr-50">
        <span
          v-if="value.editado"
          style="font-size: 12.5px;"
        >{{ value.dataAlteracao }}</span>
        <span
          v-else
          style="font-size: 12.5px;"
        >{{ value.dataCadastro }}</span>
      </div>
      <div v-if="value.editado">
        <span style="font-size: 12.5px;">(editado)</span>
      </div>
    </div>
    <div style="position: relative;">
      <button
        v-if="showSize(value.comentario)"
        class="btn-expande-text-area"
        @click="textAreaSize()"
      >
        <font-awesome-icon
          style="color:gray;"
          :icon=" newSize ? faAngleDoubleUp : faAngleDoubleDown"
        />
      </button>
      <b-textarea
        ref="observacaoInterna"
        v-model="value.comentario"
        :class="`${ newSize ? 'tramite-resize' : 'size-default'}`"
        :disabled="!editando"
        max-rows="2"
        :no-resize="true"
      />
      <div
        v-if="editando"
        style="display: flex;"
      >
        <div class="saveObservacao">
          <span
            style="cursor: pointer;text-decoration: underline;display: inline-flex;"
            @click="save({ id: value.id, observacao: value })"
          >Salvar</span>
        </div>
        <div class="cancel">
          <span
            @click="cancel()"
          >
            <i class="fas fa-times" />
          </span>
        </div>
      </div>
      <div
        v-if="!editando && permitidoEditar"
        class="edicao"
      >
        <span
          :class="['edition', {'desabilitar-inputs': permitiEditarExcluir}]"
          @click="setEdition()"
        >Editar</span>
        <span
          style="margin-left: 10px; margin-right: 10px;"
          :class="['edition', {'desabilitar-inputs': permitiEditarExcluir }]"
          @click="deletar({ id: value.id, observacao: value })"
        >Excluir</span>
      </div>
      <a
        v-if="value.anexoTramite"
        @click="openArquivo(value.anexoTramite.id)"
      >
        {{ value.anexoTramite.nomeArquivo }}
      </a>
    </div>

    <visualizar-arquivo
      v-if="visualizarArquivo"
      :url="url"
      @hidden="fecharVisualizacao()"
    />
  </div>
</template>

<style lang="scss" scoped>

.size-default {
  height: 65px;
  overflow: hidden;
}
.tramite-resize{
  height: 235px;
  overflow: auto;
}
.tramite-no-resize {
  resize: none;
}
.saveObservacao {
  margin-right: 1rem;
  margin-top: 0.5rem;
}

.cancel {
  margin-top: 0.6rem;
  cursor: pointer;
}

.edicao {
  display: inline-flex;
  font-size: 13px;
  margin-top: 0.5rem;
  .edition {
    cursor: pointer;
    text-decoration: underline;
    display: inline-flex;
  }
}
.btn-expande-text-area {
    border-radius: 50%;
    position: absolute;
    bottom: 28px;
    right: 1px;
    border: none;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faAngleDoubleDown, faAngleDoubleUp,
} from '@fortawesome/free-solid-svg-icons'
import { getUserInfo } from '@/auth/utils'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'TramiteObservacao',
  components: {
    FontAwesomeIcon,
    VisualizarArquivo: () => import('@/shared/components/visualizar-arquivo/VisualizarArquivo.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    propostaAtual: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      faAngleDoubleDown,
      faAngleDoubleUp,
      editando: false,
      visualizarArquivo: false,
      url: null,
      newSize: false,
      showReSize: false,
    }
  },
  computed: {
    permitidoEditar() {
      return this.value.usuarioNome.includes(getUserInfo().nome)
    },
    permitiEditarExcluir() {
      return this.propostaAtual && !this.value.observacaoInterno && (this.propostaAtual.statusProposta === 'expirada'
            || this.propostaAtual.etiquetas.some(som => som.descricao === 'Aprovada' || som.descricao === 'Rejeitada' || som.descricao === 'Aguardando'))
    },
  },
  methods: {
    cancel() {
      this.editando = false
    },
    save(comentario) {
      if (comentario && comentario.id > 0) {
        this.$emit('update-comentario', comentario)
      }
      this.editando = false
    },
    deletar(comentario) {
      if (comentario) {
        this.$emit('delete-comentario', comentario)
      }
    },
    setEdition() {
      this.editando = true
      this.$refs.observacaoInterna.focus()
    },
    openArquivo(anexoId) {
      api.getAnexoUrl(anexoId)
        .then(payload => {
          this.url = payload.data
          this.visualizarArquivo = true
        })
    },
    fecharVisualizacao() {
      this.visualizarArquivo = false
      this.url = null
    },
    textAreaSize() {
      this.newSize = !this.newSize
    },
    showSize(value) {
      if (/[\n|\n\r]/.test(value) || (value && value.length > 270)) {
        return true
      }
      return false
    },
  },
}
</script>
